"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _Caption = _interopRequireDefault(require("../components/Caption"));

var _redux = require("../redux"); // import app components


var Profile = function Profile(props) {
  var fields = props.fields;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      authUser = _ref.auth.user;

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    fields: fields,
    pageTitle: "Profile"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 40
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Personal Information"
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 2
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Email"
  }), /*#__PURE__*/_react.default.createElement(_antd.Typography, null, authUser === null || authUser === void 0 ? void 0 : authUser.email)), (authUser === null || authUser === void 0 ? void 0 : authUser.roles) && authUser.roles.length > 0 && /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 2
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: "Role"
  }), /*#__PURE__*/_react.default.createElement(_antd.Typography, null, authUser.roles.join(', ')))))));
};

var _default = Profile;
exports.default = _default;